import React, {useEffect, useState} from "react";

import Container from "../Container";
import Text from "../../designSystem/Text";

export interface EULAContainerProps {
    titleNumber?: number;
    isValidated: boolean;
    setIsValidated: (b: boolean) => void;
    healthCheck?: boolean;
}


const EULAContainer = (props: EULAContainerProps) => {

    const { healthCheck, setIsValidated } = props;

    const [close, setClose] = useState<boolean>(props.isValidated)
    const [eulaChecked, setEulaChecked] = useState<boolean>(props.isValidated)
    const [healthChecked, setHealthChecked] = useState<boolean>(props.isValidated)

    useEffect(
        () => setIsValidated(
            healthCheck ? (eulaChecked && healthChecked) : eulaChecked
        ),
        [healthCheck, eulaChecked, healthChecked, setIsValidated]
    )

    return (
      <Container
        containerTitle={
          "Conditions générales" +
          (props.healthCheck ? " et questionnaire de santé" : "")
        }
        titleNumber={props.titleNumber}
        close={close}
        setClose={() => setClose(!close)}
        validated={props.isValidated}
      >
        <div className={"flex flex-col gap-y-4"}>
          <div className={"flex gap-x-4 items-start"}>
            <input
              type={"checkbox"}
              checked={eulaChecked}
              className={"mt-1 cursor-pointer"}
              style={{ minWidth: "16px", minHeight: "16px" }}
              onChange={() => setEulaChecked(!eulaChecked)}
            />
            <Text>
              J'atteste avoir pris connaissance des&nbsp;
              <a
                rel="noreferrer"
                target={"_blank"}
                href={"https://www.ffvoile.fr/ffv/web/infoslegales.asp"}
              >
                conditions générales d’utilisation
              </a>
              &nbsp;de la Fédération Française de Voile, notamment l'article 6
              concernant le traitement et la protection des données
              personnelles.
            </Text>
          </div>
          <div className={"flex gap-x-4 items-start"}>
            {props.healthCheck && (
              <React.Fragment>
                <input
                  type={"checkbox"}
                  checked={healthChecked}
                  className={"mt-1 cursor-pointer"}
                  style={{ minWidth: "16px", minHeight: "16px" }}
                  onChange={() => setHealthChecked(!healthChecked)}
                />
                <Text>
                  J'atteste que toutes les questions du &nbsp;
                  <a
                    rel="noreferrer"
                    target={"_blank"}
                    href={
                      "https://www.ffvoile.fr/ffv/web/services/medical/documents/Questionnaire_Sante_FFVoile_mineur.pdf"
                    }
                  >
                    questionnaire de santé prévu à l’Annexe II-23 du Code du
                    Sport
                  </a>
                  &nbsp;ont reçu une réponse négative et que le mineur, dont je
                  suis le représentant(e) légal(e), ne présente pas de
                  contre-indication à la pratique de la voile. Je reconnais qu’à
                  travers cette attestation, j’engage ma propre responsabilité
                  et qu’en aucun cas celle de la FFVoile ne pourra être
                  recherchée.
                  <br />
                  <br />
                  <span className={"italic text-sm"}>
                    Dans l’hypothèse où l’une des réponses au questionnaire de
                    santé a été positive, nous vous invitons à vous rapprocher
                    d’un club afin de prendre votre licence et de lui fournir un
                    certificat médical daté de moins de 6 mois attestant l’absence
                    de contre-indication à la pratique de la voile (le cas échéant
                    en compétition).
                  </span>
                </Text>
              </React.Fragment>
            )}
          </div>
        </div>
      </Container>
    );
}

export default EULAContainer;